import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import { Link } from 'react-router-dom';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Topo from '../Layout/Topo';
import Loading from '../Miscelania/Loading';
import Alerta from '../Miscelania/Alerta';
import RequestApi from '../Miscelania/RequestApi';

class TeamTasksIndex extends Component {
  desativar_loading () {
    this.setState({status_loading: 0});
  } 
  
  constructor(props) {
    super(props);

    this.state = {
      status_loading: 0,
      redirect_url: false,
      mensagem_alerta: false,
      tipo_alerta: false,
      status_alerta: false,
      dados: []
    };
    this.desativar_loading = this.desativar_loading.bind(this);
    this.tarefas = this.tarefas.bind(this);
    this.botaoEdicao = this.botaoEdicao.bind(this);
  }

  componentDidMount () {
    this.refs.request_api.verifyPermission();
    this.setState({status_loading: 1});
    this.tarefas();
  }

  botaoEdicao (cell, row) {
    var split = cell.split(" - ");
    var url = '/turma/editar/' + split[1];
    var botao = (
      <Link to={url}>
        {split[0]}
      </Link>
    );

    return botao;
  }

  tarefas() {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/turmas/tarefas', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        self.setState({status_loading: 2});
        if (responseJson.status === 'success') {
          self.setState({dados: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} />
  {(this.state.status_loading !== 0) ? <Loading ativo={this.state.status_loading} desativar={this.desativar_loading} />: ""}
  {(this.state.status_alerta === 1) ? <Alerta mensagem={this.state.mensagem_alerta} tipo={this.state.tipo_alerta} desativar={this.desativar_alerta} /> : ""}
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title">Lista de tarefas</h3>
      <hr/>
      <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há tarefas cadastradas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ''}} width='60'>ID</TableHeaderColumn>

        <TableHeaderColumn dataField='turma_name_str' dataAlign="center" dataFormat={this.botaoEdicao}>Turma</TableHeaderColumn>

        <TableHeaderColumn dataField="tarefa" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Tarefa</TableHeaderColumn>

        <TableHeaderColumn dataField="date" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data</TableHeaderColumn>

        <TableHeaderColumn dataField="status" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Status</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default TeamTasksIndex;



// WEBPACK FOOTER //
// ./src/Components/TeamTasks/TeamTasksIndex.js